import { createSlice } from "@reduxjs/toolkit";
import { getClientList } from "../../reduxApi/admin/ClientReduxApi";

const clientSlice = createSlice({
    name: 'client',
    initialState: {
        status: 'idel',
        isFiltered: false,
        client: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;

            console.log('Filtered status set to:', state.isFiltered);
        },
        deleteClientAction: (state, action) => {
    // Add safety check for state.client
    if (!state.client || !Array.isArray(state.client)) {
        return;
    }
    
    action.payload.forEach((id) => {
        const index = state.client.findIndex((item) => item.ROWID === id);
        if (index !== -1) {
            state.client.splice(index, 1);
        }
    });
},

        // updateClientAction: (state, action) => {
        //     console.log(" action.payload", action.payload)
        //     const index = state.client.findIndex((item) => item.ROWID === action.payload.id)
        //     if (index != -1) {
        //         state.client.splice(index, 1, { clients: action.payload })
        //     }
        // },


//         updateClientAction: (state, action) => {
//     console.log("action.payload", action.payload)
//     const index = state.client.findIndex((item) => item.ROWID === action.payload.id)
//     if (index !== -1) {
//         // Remove the { clients: action.payload } wrapper
//         state.client.splice(index, 1, action.payload)
//     }
// },

updateClientAction: (state, action) => {
    console.log("action.payload", action.payload)
    
    // Safety check: ensure state.client exists
    if (!state.client) {
        state.client = []
        return // Exit early since there's nothing to update
    }
    
    const index = state.client.findIndex((item) => item.ROWID === action.payload.id)
    if (index !== -1) {
        state.client.splice(index, 1, action.payload)
    }
},
        // addClientAction: (state, action) => {
        //     console.log("action--->",action.payload);
            
        //     const temp = action.payload;
        //     console.log("temp",temp)
        //     temp.ROWID = action.payload.ROWID;
        //     console.log("temp.ROWID",temp.ROWID);
            
        //     state.client.unshift(temp); //add new data at beginning of array 
        // }

        addClientAction: (state, action) => {
  console.log("action--->", action.payload);
  
  const temp = action.payload;
  console.log("temp", temp);
  temp.ROWID = action.payload.ROWID;
  console.log("temp.ROWID", temp.ROWID);
  
  // Add safety check
  if (!state.client) {
    state.client = [];
  }
  
  state.client.unshift(temp); // Add new data at beginning of array 
}
    },
    extraReducers: (builder) => {
        builder.addCase(getClientList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getClientList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("action.payload",action.payload);
                state.client = action.payload.data.contact;
                console.log("state.client",state.client);
                
            })
    }
})
export const { deleteClientAction, updateClientAction, addClientAction, setFilteredStatus } = clientSlice.actions
export default clientSlice.reducer